import { render, staticRenderFns } from "./avatar-sidebar.vue?vue&type=template&id=442b755b&scoped=true&"
import script from "./avatar-sidebar.vue?vue&type=script&lang=js&"
export * from "./avatar-sidebar.vue?vue&type=script&lang=js&"
import style0 from "./avatar-sidebar.vue?vue&type=style&index=0&id=442b755b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "442b755b",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VIcon})
